import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import { BottomNavigation } from '@/components/BottomNavigation';

export const Layout = () => {
  const location = useLocation();
  return (
    <div className="relative min-h-screen">
      <div className="ns-bg-grain" />
      <AnimatePresence mode="wait">
        <motion.main
          key={location.pathname}
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -12 }}
          transition={{ duration: 0.3 }}
          className="mx-auto max-w-2xl px-5 pb-28 pt-8"
        >
          <Outlet />
        </motion.main>
      </AnimatePresence>
      <BottomNavigation />
    </div>
  );
};

export default Layout;
